/**
 * @param {object} props
 * @param {boolean} props.desired
 * @param {React.MouseEventHandler} props.onToggle
 */
export default function BenefitOption({ desired, onToggle }) {
  const text = desired ? 'Not interested?' : 'Changed your mind?';

  return (
    <span>
      <a className="benefit-option-link" onClick={onToggle}>
        ({text})
      </a>
    </span>
  );
}
